/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterY = createReactComponent(
  "square-rounded-letter-y",
  "IconSquareRoundedLetterY",
  [
    ["path", { d: "M10 8l2 5l2 -5", key: "svg-0" }],
    ["path", { d: "M12 16v-3", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedLetterY as default };
//# sourceMappingURL=IconSquareRoundedLetterY.js.map
